// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Button } from '@mantine/core';
import type { JSX } from 'react';

interface AppointmentJoinButtonProps {
  joinUrl?: string;
  withIcon?: JSX.Element;
}

export function AppointmentJoinButton({ joinUrl, withIcon }: AppointmentJoinButtonProps): JSX.Element {
  return (
    <Button
      size="xs"
      component="a"
      href={joinUrl ?? '#'}
      target="_blank"
      rel="noopener noreferrer"
      disabled={!joinUrl}
      leftSection={withIcon}
    >
      Join
    </Button>
  );
}
